import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Table from "@/components/TablePaginated.vue";
import { computed, ref } from "vue";
import { HistoryModule } from "@/store/modules/History";
import { CallDataModule } from "@/store/modules/CallData";
import TicketHistory from "./TicketsHistory.vue";
import {
	TypificationModalModule,
	actionType,
} from "@/store/modules/TypificationModal";
import { AuthModule } from "@/store/modules/Auth";
import { env } from "@/config";
import { TableColumnCtx } from "element-plus";
import { IColumn } from "@/types/components";
import typificationHistoryModal from "./typificationHistoryModal.vue";
//-> Types
export interface IPagination {
	page?: number;
	limit?: number;
	filter?: string;
	sendNumber?: boolean;
	agentCode?: string;
	today?: boolean;
	onlyOutCalls?: boolean;
}
interface IModalInfo {
	show?: boolean;
	agent_group?: string | null;
	column?: IColumn;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

//-> Imports
let showOpts = ref(false);
// ===> Const
const itemValues = [
	{ value: "Mi_historial", label: "Mi historial" },
	{ value: "Buscador", label: "Buscador" },
];
const activeName = ref("first");
const modal = ref<IModalInfo>({
	show: false,
	agent_group: "",
	column: undefined,
});

// ==> Let
let timer: ReturnType<typeof setTimeout>;

// ===> Computed
const History = computed(() => {
	return (HistoryModule.HistoryUser ? HistoryModule.HistoryUser : {}) as any;
});
const user = computed(() => AuthModule.user);
const loading = computed(() => {
	return HistoryModule.Loading;
});
// ===> Methods
function onEditClient(row: any) {
	const data = row.rawData;
	TypificationModalModule.setData(data);
	TypificationModalModule.setIdSql(row.id);
	TypificationModalModule.setIdMongo(row._id);
	TypificationModalModule.setType(actionType.edit);
	CallDataModule.setScore(true);
	CallDataModule.getCallCenterClient(row.Numero);
	CallDataModule.setActiveCall({
		call_number: row.Numero,
		uniqueid: "",
		call_status: undefined,
		resultado: 0,
		call_type: row.Tipo,
		queue: row.queue,
		id: row._id,
	});
}
function callback(pag: IPagination, select = "") {
	showOpts.value = true;
	if (select != "" && select == itemValues[1].value) {
		showOpts.value = false;
		pag.agentCode = "";
		pag.today = false;
		pag.onlyOutCalls = env.onlyOutCallsGlobalCallHistory;
	}

	// console.log(showOpts);
	pag != undefined
		? HistoryModule.updateUserHistory(pag)
		: HistoryModule.updateUserHistory(undefined);
}
function callInputback(pag: IPagination, select = "") {
	clearTimeout(timer); // Reiniciar el temporizador
	timer = setTimeout(function () {
		callback(pag, select);
	}, 500);
}
const handleClick = () => {
	HistoryModule.setHistoryUser(undefined);
};
async function onRowClick({
	row: rowValue,
}: {
	row: IColumn;
	col: TableColumnCtx<any>;
	e: PointerEvent;
}) {
	modal.value.show = true;
	modal.value.column = rowValue ?? undefined;
	modal.value.agent_group = rowValue?.agent_group ?? null;
}
const changeModal = ({ show }: { show: boolean }) => {
	modal.value.show = show;
};

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeName).value = $event)),
      type: "card",
      class: "shadow-sm p-3",
      onTabClick: handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "Calificación de llamadas",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createVNode(Table, {
              onUpdateData: _cache[0] || (_cache[0] = (payload) => {
					callback({ ...payload.pagination, sendNumber: true });
				}
				),
              onUpdateInputData: _cache[1] || (_cache[1] = (payload) => {
					callInputback({ ...payload.pagination, sendNumber: true });
				}
				),
              tableData: _unref(History),
              load: _unref(loading),
              tittle: "Calificación de llamada",
              tittlebtn: "Actualizar",
              disabled: !_unref(CallDataModule).scoring,
              btn: true,
              filter: true,
              tableLayout: "fixed",
              cardClass: "m-1",
              information: true,
              informationLabel: "Se puede buscar por <ul>\r\n\t\t\t\t\t\t\t\t<li>Tipo</li>\r\n\t\t\t\t\t\t\t\t<li>Cola</li>\r\n\t\t\t\t\t\t\t\t<li>Cliente</li>\r\n\t\t\t\t\t\t\t\t<li>Número</li>\r\n\t\t\t\t\t\t\t\t<li>Agente</li>\r\n\t\t\t\t\t\t\t\t</ul>",
              onRowClick: onRowClick
            }, null, 8, ["tableData", "load", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Calificación Global",
          name: "second"
        }, {
          default: _withCtx(() => [
            _createVNode(Table, {
              onEdit: onEditClient,
              onUpdateData: _cache[2] || (_cache[2] = (payload) => {
					callback({
						...payload.pagination,
						sendNumber: false,
						agentCode: _unref(user)?.code ?? '',
						today: true,
					}, payload.typeSelect);
				}
				),
              onUpdateInputData: _cache[3] || (_cache[3] = (payload) => {
					callInputback({ ...payload.pagination, sendNumber: false, agentCode: _unref(user)?.code ?? '', today: true }, payload.typeSelect);
				}
				),
              tableData: _unref(History),
              load: _unref(loading),
              tittle: "Calificación Global",
              tittlebtn: "Actualizar",
              disabled: false,
              btn: true,
              filter: true,
              "show-options": _unref(showOpts) && _unref(env).DynamicTypification,
              cardClass: "m-1",
              tableLayout: "fixed",
              select: true,
              selectArray: itemValues,
              defaultSelect: itemValues[0].value,
              information: true,
              informationLabel: "Se puede buscar por <ul>\r\n\t\t\t\t\t\t\t\t<li>Tipo</li>\r\n\t\t\t\t\t\t\t\t<li>Cola</li>\r\n\t\t\t\t\t\t\t\t<li>Cliente</li>\r\n\t\t\t\t\t\t\t\t<li>Número</li>\r\n\t\t\t\t\t\t\t\t<li>Agente</li>\r\n\t\t\t\t\t\t\t\t</ul>"
            }, null, 8, ["tableData", "load", "show-options", "defaultSelect"])
          ]),
          _: 1
        }),
        (
				_unref(env).requiredCallcenter &&
					!_unref(env).onlyCallcenter &&
					_unref(CallDataModule).user?._id
			)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "Historial de tickets",
              name: "third"
            }, {
              default: _withCtx(() => [
                _createVNode(TicketHistory)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(typificationHistoryModal, {
      show: modal.value.show,
      agent_group: modal.value.agent_group,
      column: modal.value.column,
      onChangeModal: _cache[5] || (_cache[5] = s => changeModal(s))
    }, null, 8, ["show", "agent_group", "column"])
  ], 64))
}
}

})